<app-warehouse-material class="subpage-content"></app-warehouse-material>

<div #dialogFooter></div>
